export const environment = {
  production: true,
  api: 'https://api-safetrace.qualidadepereciveis.com.br',
  safeGisUrl: 'https://safegis.qualidadepereciveis.com.br'
};
